import { Box, Typography } from "@mui/material";
import { SPACING } from "../constants/spacing";

const PageHeader = ({ title, description, appendActions }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: SPACING.sm,
        mb: SPACING.xl,
      }}
    >
      <Box
        style={{
          gap: SPACING.sm,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          maxWidth: 500,
        }}
      >
        {typeof title === "string" ? (
          <Typography variant="h1">{title}</Typography>
        ) : (
          title
        )}
        {description && (
          <Typography variant="bodyMd" component="p">
            {description}
          </Typography>
        )}
      </Box>
      {appendActions && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: SPACING.sm,
          }}
        >
          {appendActions}
        </Box>
      )}
    </Box>
  );
};

export default PageHeader;
